import { useEffect } from "react";

/**
 * Lightweight SEO head helper for react-scripts (no react-helmet dependency).
 * Sets document.title + description/canonical/og meta tags per route.
 */
const ensureMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
};

const ensureLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return el;
};

export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      ensureMeta('meta[name="description"]', { name: "description", content: description });
      ensureMeta('meta[property="og:description"]', { property: "og:description", content: description });
    }
    if (title) {
      ensureMeta('meta[property="og:title"]', { property: "og:title", content: title });
      ensureMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    }
    if (path) ensureLink("canonical", `https://parkcollections.co.in${path}`);
  }, [title, description, path]);
}
